import { Fragment, h } from "preact";
import { RoutableProps } from "preact-router";
import { useCallback, useState } from "preact/hooks";
import { Button, Container, FormField } from "uitoolkit";
import { usePageTitle } from "hooks";
import { isValidEmail } from "services/utils";
import { requestResetPasswordEmail } from "services/backend";
import { translate } from "services/translations";

export const ForgotPasswordBox = (props: RoutableProps) => {
    usePageTitle(translate("forgotpassword_pagetitle"));

    const [showValidation, setShowValidation] = useState(false);
    const [isSent, setIsSent] = useState(false);
    const [email, setEmail] = useState("");
    const [waiting, setWaiting] = useState(false);

    const onSend = useCallback(async () => {
        setShowValidation(true);
        if (!isValidEmail(email)) return;
        setShowValidation(false);
        setWaiting(true);
        const res = await requestResetPasswordEmail(email);
        setWaiting(false);
        if (!res?.data?.user.requestResetPasswordEmail?.ok) {
            // todo: warning, email not found
            return;
        }
        if (!res || (res.errors?.length ?? 0) > 0) {
            // todo: warning
            return;
        }
        setIsSent(true);
    }, [email])

    const handleEnter = useCallback((e: KeyboardEvent) => {
        if (e.key == "Enter")
            onSend();
    }, [onSend]);

    return (
        <Container class="component-form flex-column gap-16" onKeyUp={handleEnter}>
            {
                isSent &&
                <Fragment>
                    <header>
                        <h1>{translate("forgotpassword_headline_sent")}</h1>
                        <h2>{translate("forgotpassword_description_sent")}</h2>
                    </header>
                </Fragment>
            }
            {
                !isSent &&
                <Fragment>
                    <header>
                        <h1>{translate("forgotpassword_headline")}</h1>
                        <h2>{translate("forgotpassword_description").replace("\\n", " ")}</h2>
                    </header>
                    <FormField
                        id="email"
                        type="email"
                        label={translate("forgotpassword_label_email")}
                        placeholder={translate("forgotpassword_placeholder_email")}
                        disabled={waiting}
                        value={email}
                        autoComplete="email"
                        state={!showValidation ? undefined : (!isValidEmail(email) ? "invalid" : "valid")}
                        onChange={e => setEmail((e.target as any).value)} />
                    <Button
                        variant="primary"
                        size="large"
                        class="wide"
                        onClick={onSend}>{translate("forgotpassword_button_sendemail")}</Button>
                </Fragment>
            }
        </Container>
    );

};
